/**
 * Escapes a CSV field per RFC 4180 with formula injection protection.
 * Prepends apostrophe to values starting with formula characters (= + - @)
 * to prevent spreadsheet apps from treating them as formulas.
 * Wraps in double quotes and escapes internal double quotes by doubling them.
 */
export const escapeCsvField = (value: string): string => {
  let sanitized = value;
  // Protect against CSV formula injection for untrusted input
  const trimmed = value.trimStart();
  if (/^[=+\-@]/.test(trimmed)) {
    sanitized = "'" + value;
  }
  const escaped = sanitized.replace(/"/g, '""');
  return `"${escaped}"`;
};

/**
 * Triggers a CSV file download in the browser.
 */
export const downloadCsv = (content: string, filename: string): void => {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
